export default __webpack_public_path__ + "static/media/icono-calendario.f2dc6293.png";